/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  }

  growApp.prototype.moreText = function () {
    $('.c-block-text__button').on('click', function() {
      if( $(this).children().is('.open') ) {
        $(this).html('<div class="c-button is-md close">閉じる</div>').addClass('close-btn');
        $(this).parent().removeClass('slide-up').addClass('slide-down');
      } else {
        $(this).html('<div class="c-button is-md open">もっと見る</div>').removeClass('close-btn');
        $(this).parent().removeClass('slide-down').addClass('slide-up');
      }
    });
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.moreText();
  });
})(jQuery);
